// MODIFIED
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { formatCurrency } from "../../../../../utils/textUtils";
import { StatusBadge } from "../../../../../common/Badge";

const LeaveIncentiveViewModal = ({ isOpen, onClose, data }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3 animate-fadeIn">
      <div className="bg-white w-full max-w-2xl rounded-lg shadow-xl overflow-hidden">
        <div className="flex justify-between items-center px-6 py-4 border-b bg-gray-50">
          <h2 className="text-lg font-bold text-gray-700">Incentive Breakdown</h2>
          <button onClick={onClose} className="border-none bg-transparent cursor-pointer text-gray-400 hover:text-gray-600">
            <CloseIcon />
          </button>
        </div>

        <div className="p-0 max-h-[60vh] overflow-y-auto relative">

          <table className="w-full border-collapse text-left">
            <thead className="sticky top-0 bg-gray-100 shadow-sm">
              <tr>
                <th className="p-4 text-xs font-semibold uppercase text-gray-600 border-b">Period</th>
                <th className="p-4 text-xs font-semibold uppercase text-gray-600 border-b">Rate</th>
                <th className="p-4 text-xs font-semibold uppercase text-gray-600 border-b">Absents</th>
                <th className="p-4 text-xs font-semibold uppercase text-gray-600 border-b">Amount</th>
                <th className="p-4 text-xs font-semibold uppercase text-gray-600 border-b text-center">Released</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {data.length > 0 ? data.map((li) => (
                <tr key={li.id} className="hover:bg-blue-50 transition-colors">
                  <td className="p-4 text-sm text-gray-700 font-medium">{li.month} {li.year}</td>
                  <td className="p-4 text-sm text-gray-600">{formatCurrency(li.rate)}</td>
                  <td className="p-4 text-sm text-gray-600">{li.totalAbsents || 0}</td>
                  <td className="p-4 text-sm font-semibold text-blue-700">{formatCurrency(li.amount)}</td>
                  <td className="p-4 text-center">
                    {console.log({li})}
                    <StatusBadge status={li.isReleased ? "Released" : "Pending"} />
                  </td>
                </tr>
              )) : (
                <tr>
                  <td colSpan="5" className="p-8 text-center text-gray-400">No historical records found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="flex justify-end gap-2 p-4 border-t bg-gray-50">
          <button onClick={onClose} className="px-5 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-md transition-colors cursor-pointer border-none font-medium">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeaveIncentiveViewModal;